import $ from '@modules/jquery-import';
import {jqueryValidate} from '@modules/lazy-imports';
import assign from 'object-assign';
import debounce from 'lodash.debounce';
import ProductCatalogService from '@services/ProductCatalogService/';

const getActiveStarRating = $inputGroup =>
    $inputGroup.filter( 'input:checked' ).val() || 0;

const setActiveStarRating = $inputGroup => {
    const selectedRating = getActiveStarRating( $inputGroup );
    toggleActiveStars( $inputGroup, selectedRating )
};

const toggleActiveStars = debounce( ( $inputGroup, selectedRating ) => {
    if ( selectedRating == null ) {
        selectedRating = 0;
    }

    $inputGroup.each( ( i, radio ) => {
        const isInRange = parseInt( radio.value, 10 ) <= parseInt( selectedRating, 10 );
        $( radio ).siblings( '.radio' ).toggleClass( 'checked fade-in', isInRange );
    } )
}, 50 );

const HTML = {
    actionButtons: `
        <div class="flex justify-between md:flex-row-reverse mt-2 md:m-0">
            <button class="button ghosted" data-action="cancel">Cancel</button>
            <button class="button md:ml-2" data-action="save">Save</button>
        </div>
    `,
    selectedProduct: ( {kitName, image, isEditable} ) => `
        <div class="flex items-center md:w-3/4 fade-in">
            <div class="w-32 flex-0">
                <span class="img-ratio-4x3">
                    <picture>
                        <source srcset="${image.source}?w=256&fm=webp" type="image/webp" />
                        <source srcset="${image.source}?w=256" />
                        
                        <img src="${image.source}?w=256" alt="${kitName}">
                    </picture>
                </span>
            </div>
            <div class="ml-4">
                <h3 class="mb-2 mr-2 md:text-lg inline">${kitName}</h3>
                ${isEditable ? HTML.changeAction : ''}
            </div>
        </div>
    `,
    changeAction: `<span class="link-2" data-action="change">Change</span>`
};

const proto = {

    nodes: {
        product: {}
    },

    onDOMLoad () {
        const $nodes = this.nodes.product;
        $nodes.select = $( '#productOption' );

        this.initForm();
        this.initRatingSelector();

        // we only initialize the product selector if there is a default selection provided from server
        // otherwise we just treat this as a normal select field to keep the form flow simple
        if ( $nodes.select.val() !== '' ) {
            this.initProductSelector();
        }
    },

    onWindowLoad () {
        // fixme -> we initialize this a second time due to a race-condition with lazy-loaded plugins
        // improve load time of plugins in order to remove this extra call
        const $starRadios = $( '.star-rating-radio-group' ).find( 'input:radio' );
        setActiveStarRating( $starRadios );
    },

    async initForm () {
        await jqueryValidate();
        $( this.formId ).validate();
    },

    initRatingSelector () {
        const $starRatingSelector = $( '.star-rating-radio-group' );
        const $starRadios = $starRatingSelector.find( 'input:radio' );

        // set selected star from timeout to race condition with initialization phase of custom radio component
        setActiveStarRating( $starRadios );

        // initialize star-rating-radio-group
        $starRatingSelector.find( 'label' ).hide();
        $starRadios.on( 'click change mouseenter', e => toggleActiveStars( $starRadios, e.target.value ) );
        $starRadios.on( 'mouseleave', e => setActiveStarRating( $starRadios ) );
    },

    initProductSelector () {
        const $nodes = this.nodes.product;
        $nodes.select = $( '#productOption' );
        $nodes.container = $( '#brand-product-option-container' );
        $nodes.editContainer = $( '#brand-product-option-edit' );
        $nodes.fieldContainer = $( '#brand-product-option-select' );
        $nodes.detail = $( '<div/>' ); // placeholder
        $nodes.actions = $( HTML.actionButtons );
        $nodes.container.prepend( $nodes.detail );
        $nodes.fieldContainer.append( $nodes.actions );

        // remove the first "empty" option from list to simplify validation since we know there was default selection
        $nodes.select.find( 'option' ).eq( 0 ).remove();

        // if there is only one option left, set as default and remove ability to edit
        let options = $nodes.select.find( 'option' );
        if ( options.length === 1 ) {
            options.eq( 0 ).attr( 'selected' );
            this.isEditable = false;
        }

        this.renderProductDetail( $nodes.select.val() );
        this.toggleProductEditMode( false );

        // init events
        $nodes.container.on( 'click', '[data-action]', this.handleProductSelectAction.bind( this ) );
    },

    handleProductSelectAction ( e ) {
        e.preventDefault();
        const action = e.target.getAttribute( 'data-action' );

        switch ( action ) {
            case 'change':
                this.onEditProductSelection();
                break;

            case 'save':
                this.onSaveProductSelection();
                break;

            case 'cancel':
                this.onCancelProductSelection();
                break;

            default:
                console.warn( 'handleProductSelectAction: ignoring unknown action' );
            // do nothing
        }
    },

    renderProductDetail ( sku ) {
        const {detail} = this.nodes.product;
        const {isEditable} = this;

        return ProductCatalogService.getDetail( sku )
            .then( ( {kitName, images} ) => {
                const html = $( HTML.selectedProduct( {kitName, image: images[0], isEditable} ) );
                detail.html( html );
            } );
    },

    onEditProductSelection () {
        this.toggleProductEditMode( true );
    },

    async onSaveProductSelection () {
        const {select, actions} = this.nodes.product;
        const sku = select.val();
        const saveButton = actions.find( '[data-action=save]' );

        saveButton.addClass( 'processing' );
        if ( sku ) {
            await this.renderProductDetail( sku );
            saveButton.removeClass( 'processing' );
            this.toggleProductEditMode( false );
        }
    },

    onCancelProductSelection () {
        this.toggleProductEditMode( false );
    },

    toggleProductEditMode ( isEditMode ) {
        const {detail, editContainer} = this.nodes.product;
        detail.toggle( !isEditMode );
        editContainer.toggle( isEditMode );
    }

};

const page = ( formId ) => assign( Object.create( proto ), {
    formId,
    isEditable: true
} );
const reviewPage = page( '#brandReviewForm' );

$( document ).ready( function () {
    reviewPage.onDOMLoad();
} );

$( window ).on( 'load', function () {
    reviewPage.onWindowLoad();
} );
